export interface ComboboxItem {
  id: number;
  label: string;
}
export const EmptyComboboxItem = { id: 0, label: '' };
export interface IComboBoxItem {
  id: number;
  label: string;
}

export class UtilityService {
  public static checkEmailIsGuid(emailAddress: any) {
    let emailFP = emailAddress.substring(0, emailAddress.indexOf('@'));
    let pattern = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
    return emailFP.match(pattern) ? '' : emailAddress;
  }
  public static isNullOrEmpty(value: string | null | undefined) {
    return !value || value === undefined || value === '' || value.length === 0;
  }
  public static isNumber(value: string | null) {
    return value != null && value !== '' && !isNaN(Number(value.toString()));
  }
  public static isNumberOrEmpty(value: string | null) {
    return (value != null && value !== '' && !isNaN(Number(value.toString()))) || value === '';
  }
  public isNullOrEmpty(value: string) {
    return !value || value === undefined || value === '' || value.length === 0;
  }
  public isNull(value: any) {
    return !value || value === undefined;
  }
  public replace(arg: any) {
    return String(arg).replace('.', ' : ');
  }
  public static highLight(input, highLight) {
    if (this.isNullOrEmpty(highLight)) return input;
    if (input.includes(highLight))
      input = input.replaceAll(highLight, '<span class="Highlight">' + highLight + '</span>');
    return input;
  }
  public static makeSameSize(input, fitLenght) {
    if (this.isNullOrEmpty(input)) return input;
    if (input.length > fitLenght) input = input.replace(/^(.{65}[^\s]*).*/, '$1') + ' ...'; // input.substring(0, fitLenght) + " ...";
    return input;
  }
  public addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }
  public getDate(str: string) {
    if (str !== '' && str.length > 10) {
      const d = new Date(str).toDateString();
      //  d=  new Date(str).toLocaleDateString()
      // let d2 = new Date(str);
      // let fd = d2.toLocaleDateString() + ' ' + d2.toTimeString().substring(0, d2.toTimeString().indexOf("GMT"));

      return d;
    }
    return str;
  }
  public static b64toBlob(b64Data: string, contentType = '') {
    const byteCharacters2 = atob(b64Data);
    const byteNumbers = new Array(byteCharacters2.length);
    for (let i = 0; i < byteCharacters2.length; i++) {
      byteNumbers[i] = byteCharacters2.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob2 = new Blob([byteArray], { type: contentType });
    return blob2;
  }
  public static b64toUrl(b64Data: string, contentType = '') {
    const fileUrl = URL.createObjectURL(this.b64toBlob(b64Data, contentType));
    return fileUrl;
  }

  public static GetFileExtension(fileName: string) {
    let regex = new RegExp('[^.]+$');
    return fileName.toLowerCase().match(regex);
  }
  public static IsFileAnImage(fileName: string) {
    let regex = new RegExp('[^.]+$');
    let ext = fileName.match(regex)?.toString().toLowerCase();
    return ext?.includes('png') || ext?.includes('jpg') || ext?.includes('gif') || ext?.includes('jpeg');
  }
  public static GetRandomNumber(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}

export default UtilityService;
